// extracted by mini-css-extract-plugin
export default {"container":"InputControl_container__XpPKO","inputContainer":"InputControl_inputContainer__H49sI","icon":"InputControl_icon__2GHZ7"};